document.querySelectorAll('.tab-click--js').forEach(function (tabBtn) {
    tabBtn.addEventListener('click', function (evt) {
        const blockId = tabBtn.getAttribute('data-block-id');
        const sectionId = tabBtn.getAttribute('data-section-id');
        document.querySelectorAll('.tab-click--js').forEach(function (btn) {
            btn.classList.remove('tab-btn--item-active');
        });
        tabBtn.classList.add('tab-btn--item-active');
        document.querySelectorAll(`.tab-details-content--${sectionId}--js`).forEach(function (tabContent) {
            tabContent.classList.remove('show');
            tabContent.classList.add('hide');
        });
        document.querySelectorAll(`.image-item--${sectionId}--js`).forEach(function (imageItem) {
            imageItem.classList.remove('show');
            imageItem.classList.add('hide');
        });
        const tabDetailsContent = document.getElementById(`tab-details-content--${blockId}`);
        const imageItem = document.getElementById(`image-item--${blockId}`);

        if (tabDetailsContent && imageItem) {
            tabDetailsContent.classList.remove('hide');
            tabDetailsContent.classList.add('show');

            imageItem.classList.remove('hide');
            imageItem.classList.add('show');
        }
    });
});

document.querySelectorAll(".tab-btn--select--js").forEach(function(tabSelect){
    tabSelect.addEventListener("change", function(evt){
        console.log("evt.target==>",evt.target.value)
        document.getElementById(`item-tab-btn--${evt.target.value}`).click();
    })
})

document.querySelector(".addtional-input")?.addEventListener("input", function() {
    if (document.getElementById("checkbox-additional-btn").checked) {
        document.getElementById("add-on-total-add").style.display = "block";
       let addOnVariantId =  document.getElementById("checkbox-additional-btn").getAttribute("data-add-on-variant-id");
       if(addOnVariantId){
        document.querySelector("form[data-type='add-to-cart-form'] .product-form__submit").classList.add("add-on-product-checked")
       }else{
        document.querySelector("form[data-type='add-to-cart-form'] .product-form__submit").classList.remove("add-on-product-checked")
       }
    } else {
        document.getElementById("add-on-total-add").style.display = "none";
        document.querySelector("form[data-type='add-to-cart-form'] .product-form__submit").classList.remove("add-on-product-checked")

    }
});


$(document).on("click", ".product-form__input input", function() {
    var __this = $(this);
    var size_text = $(this).val();

    setTimeout(function(){
        if ($("#checkbox-additional-btn").prop("checked") === true) {
            $("#checkbox-additional-btn").trigger("click")
        }
        let varinatId = $("form[data-type='add-to-cart-form']").find('[name="id"]').val();
        if (varinatId == undefined) return;
        let selectedAddOn = $(`#add-on-${varinatId}`).val();
        if(selectedAddOn){
            $("#add-on-checkbox-container").css("display","block");
            let selectedAddOnPrice = $(`#add-on-${varinatId}`).attr("data-price");
            let selectedAddOnTitle = $(`#add-on-${varinatId}`).attr("data-add-on-title");
            $("#addtional-price").html("+("+selectedAddOnPrice + ")");
            $("#add-on-total-add-price").html(selectedAddOnPrice);
            $("#addtional-product-title").html(selectedAddOnTitle);
            $("#checkbox-additional-btn").attr("data-add-on-variant-id",selectedAddOn)


            var vPriceTxt = $(".product__info-container .price-item--regular > .money").text();
            var currancy = vPriceTxt.split(".")[0];
            let vPriceP = vPriceTxt.replace(/[^\d.]/g, '');
            vPriceP = vPriceP.replace(/^0+(\d)/, '$1');
            vPriceP = parseInt(vPriceP.replace(/^(\.)(\d)/, '$2'));

            let dimensions = size_text.split('x');
            // Remove extra text like "ft" and trim the result
            let length = parseFloat(dimensions[0].replace(/[^\d.]/g, ''));
            let width = parseFloat(dimensions[1].replace(/[^\d.]/g, ''));
            var ftArea = length * width;
            var ftAreaP = parseInt(vPriceP/ftArea);
            console.log("objectlll===>",ftAreaP)
            $("#material-subtext--psft > .money").html(currancy+". "+ftAreaP.toFixed(2))


        }else{
            $("#add-on-checkbox-container").css("display","none");
            $("#checkbox-additional-btn").attr("data-add-on-variant-id","")
        }
    }, 1000);
});

$(document).on("click", ".add-on-product-checked", function(evt) {
     evt.preventDefault();
     let varinatId = $("form[data-type='add-to-cart-form']").find('[name="id"]').val();
     let quantity = $("form[data-type='add-to-cart-form']").find('[name="quantity"]').val();
     let selectedAddOn = $(`#add-on-${varinatId}`).val();
     let formData = {
        'items': [
            {
                id : varinatId,
                quantity: quantity 
            },
            {
                id : selectedAddOn,
                quantity: 1
            }
        ]
    };

    fetch(`/cart/add.js`,{
        method: "POST",
        headers:{
            "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        return response.json(); 
    })
    .then(data => {
       
        if (data.status == 422){
        $(".product-form__error-message-wrapper").find(".product-form__error-message").html(data.message)
        $(".product-form__error-message-wrapper").attr("hidden", false);
        }else{
           window.location.href="/cart"
        }
    })
 
    .catch((error) => {
        console.error('Error:', error);  // Log any errors that occurred
        $(".product-form__error-message-wrapper").find(".product-form__error-message").html(data.message)
        $(".product-form__error-message-wrapper").attr("hidden", false);
    });

});

$(document).on("click", ".product-form__input input", function() {
    
    // var size_text = $(this).val();

    // let dimensions = size_text.split('x');
    // // Remove extra text like "ft" and trim the result
    // let length = parseFloat(dimensions[0].replace(/[^\d.]/g, ''));
    // let width = parseFloat(dimensions[1].replace(/[^\d.]/g, ''));
    // // Extract numbers from the format (e.g., 5x8)
    // // const dims = dimensions.split('x');
    // // const length = parseFloat(dims[0]);
    // // const width = parseFloat(dims[1]);

    // // // Calculate area
    // const area = length * width;
    // console.log(length,width, "area===>",area)
})

function addInstantToCart( evt, current_inst){
    var varianId = current_inst.getAttribute("data-variant_id");
    console.log("varianIdvarianId==>",varianId,current_inst.innerHTML)

    fetch('/cart/add.js', {
        method: 'POST',
        headers:{
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            'items': [
            {
                id : varianId,
                quantity: 1 
            }]
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(data => {
        console.log("v===>",data);
        current_inst.innerHTML = '<span class="btn with-plus tick"></span>';
        updateCartDrawer();
        document.getElementById("cart-icon-bubble").click();
      })
      .catch(error => {
        console.error('Error:', error);
      });

}

// function updateCartDrawer() {
//     fetch('/?section_id=cart-drawer')
//       .then(response => response.text())
//       .then(html => {
//         console.log("html==>",html)
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const newCartDrawer = doc.querySelector('#CartDrawer');
//         const currentDrawer = document.querySelector('#CartDrawer');
//         console.log("currentDrawercurrentDrawer==>",currentDrawer, currentDrawer)
//         if (newCartDrawer && currentDrawer) {
//           currentDrawer.innerHTML = newCartDrawer.innerHTML; 
//         }
//       });
//   }
  
function updateCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('#CartDrawer');
        const currentDrawer = document.querySelector('#CartDrawer');
  
        if (newCartDrawer && currentDrawer) {
            currentDrawer.parentElement.classList.remove("is-empty")
          currentDrawer.replaceWith(newCartDrawer);
  
          // Process scripts and styles from the new HTML
          replaceStyleAndScript(doc);
        }
      });
  }

  function replaceStyleAndScript(doc) {
    // Replace <style>
    const newStyle = doc.querySelector('style[data-cart-drawer]');
    const oldStyle = document.head.querySelector('style[data-cart-drawer]');
    if (oldStyle) oldStyle.remove();
    if (newStyle) document.head.appendChild(newStyle.cloneNode(true));
  
    // Replace <script>
    const newScript = doc.querySelector('script[data-cart-drawer]');
    const oldScript = document.body.querySelector('script[data-cart-drawer]');
    if (oldScript) oldScript.remove();
    if (newScript) {
      const script = document.createElement('script');
      if (newScript.src) {
        script.src = newScript.src;
      } else {
        script.textContent = newScript.textContent;
      }
      script.setAttribute('data-cart-drawer', '');
      document.body.appendChild(script);
    }
  }
  
  
  